/* NUKUMU — header state, mobile nav, scroll-reveal */
(function () {
  var header = document.getElementById('nk-header');

  function onScroll() {
    if (!header) return;
    var solid = window.scrollY > 60 || header.dataset.transparent !== 'true';
    header.classList.toggle('nk-header--solid', solid || header.classList.contains('nk-menu-open'));
  }

  if (header) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var toggle = header.querySelector('.nk-menu-toggle');
    var mobileNav = header.querySelector('.nk-mobile-nav');
    if (toggle && mobileNav) {
      toggle.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('nk-open');
        header.classList.toggle('nk-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        onScroll();
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 768 && mobileNav.classList.contains('nk-open')) {
          mobileNav.classList.remove('nk-open');
          header.classList.remove('nk-menu-open');
          toggle.setAttribute('aria-expanded', 'false');
          onScroll();
        }
      });
    }
  }

  var reveal = function () {
    var els = document.querySelectorAll('.nk-fade-up');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nk-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nk-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '-60px 0px', threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();

/* ===== NUKUMU cart drawer + waitlist modal ===== */
(function () {
  var overlay = document.querySelector('[data-nk-overlay]');
  var drawer = document.querySelector('[data-nk-cart-drawer]');
  var modal = document.querySelector('[data-nk-waitlist-modal]');
  if (!overlay || !drawer) return;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
    el.classList.toggle('nk-open', !hidden);
  }

  function closeAll() {
    setHidden(drawer, true);
    setHidden(modal, true);
    setHidden(overlay, true);
    document.body.style.overflow = '';
  }

  function openPanel(panel) {
    closeAll();
    setHidden(overlay, false);
    setHidden(panel, false);
    document.body.style.overflow = 'hidden';
  }

  overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.querySelectorAll('[data-nk-drawer-close], [data-nk-waitlist-close]').forEach(function (b) {
    b.addEventListener('click', closeAll);
  });

  /* ---- cart drawer ---- */
  var linesEl = drawer.querySelector('[data-nk-drawer-lines]');
  var subtotalEl = drawer.querySelector('[data-nk-drawer-subtotal]');
  var countEl = drawer.querySelector('[data-nk-drawer-count]');

  function updateHeaderCount(count) {
    var btn = document.querySelector('.nk-cart-btn');
    if (!btn) return;
    var badge = btn.querySelector('.nk-cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'nk-cart-count';
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function renderCart(cart) {
    countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    subtotalEl.textContent = money(cart.items_subtotal_price);
    updateHeaderCount(cart.item_count);
    if (!cart.items.length) {
      linesEl.innerHTML = '<p class="nk-drawer-empty">Your bag is empty. The quiet is waiting.</p>';
      return;
    }
    linesEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      return (
        '<div class="nk-drawer-line">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<div class="nk-drawer-line-info">' +
            '<a href="' + item.url + '" class="nk-drawer-line-title">' + item.product_title + '</a>' +
            '<p class="nk-drawer-line-price">' + money(item.final_price) + '</p>' +
            '<div class="nk-drawer-line-qty">' +
              '<button type="button" data-nk-line-qty="-1" data-line="' + (i + 1) + '" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-nk-line-qty="1" data-line="' + (i + 1) + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>' +
              '<button type="button" class="nk-drawer-remove" data-nk-line-remove data-line="' + (i + 1) + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<p class="nk-drawer-line-total">' + money(item.final_line_price) + '</p>' +
        '</div>'
      );
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(); });
  }

  linesEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-nk-line-qty]');
    if (qtyBtn) {
      var next = parseInt(qtyBtn.dataset.qty, 10) + parseInt(qtyBtn.dataset.nkLineQty, 10);
      changeLine(parseInt(qtyBtn.dataset.line, 10), Math.max(0, next));
      return;
    }
    var removeBtn = e.target.closest('[data-nk-line-remove]');
    if (removeBtn) changeLine(parseInt(removeBtn.dataset.line, 10), 0);
  });

  var cartBtn = document.querySelector('.nk-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(function () { openPanel(drawer); });
    });
  }

  /* AJAX add-to-cart: intercept every product form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCart();
      })
      .then(function () { openPanel(drawer); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---- waitlist modal ---- */
  if (modal) {
    var productEl = modal.querySelector('[data-nk-waitlist-product]');
    var tagsInput = modal.querySelector('[data-nk-waitlist-tags]');
    var formState = modal.querySelector('[data-nk-waitlist-form-state]');
    var successState = modal.querySelector('[data-nk-waitlist-success]');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-nk-waitlist]');
      if (!trigger) return;
      e.preventDefault();
      var product = trigger.getAttribute('data-nk-waitlist') || 'your companion';
      if (productEl) productEl.textContent = product;
      if (tagsInput) tagsInput.value = 'waitlist, waitlist-' + product.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      formState.hidden = false;
      successState.hidden = true;
      openPanel(modal);
    });

    var waitlistForm = modal.querySelector('.nk-waitlist-form');
    if (waitlistForm) {
      waitlistForm.addEventListener('submit', function () {
        try { sessionStorage.setItem('nkWaitlistPending', '1'); } catch (err) {}
      });
    }

    try {
      if (sessionStorage.getItem('nkWaitlistPending') === '1' && location.search.indexOf('customer_posted=true') !== -1) {
        sessionStorage.removeItem('nkWaitlistPending');
        formState.hidden = true;
        successState.hidden = false;
        openPanel(modal);
      }
    } catch (err) {}
  }
})();
